export const homeObjOne = {
  id: "accueil",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Nos activités",
  headLine: "JJK SERVICES : la clé de votre transformation numérique",
  description:
    "Nous sommes une équipe de professionnels hautement qualifiés, spécialisés dans la conception de sites Web, le développement d'applications mobiles, la création de contenu graphique, et bien plus encore...",
  buttonLabel: "Découvrir",
  imgStart: false,
  img: require("../../images/equipe.png"),
  alt: "Création d'un projet",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "services",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Nos Services",
  headLine: "Des solutions numériques innovantes pour votre entreprise",
  description:
    "Nous créons des sites web personnalisés avec les dernières technologies et pratiques de conception. Nous développons des applications mobiles pour iOS et Android. Nous offrons des services de marketing numérique pour atteindre votre public cible et aider votre entreprise à se démarquer",
  buttonLabel: "En savoir plus",
  imgStart: true,
  img: require("../../images/services.png"),
  alt: "Séance de travail",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Contactez Nous",
  headLine: "Prenez contact avec nous pour des solutions numérique sur mesure",
  description:
    "Contactez-nous pour discuter de vos besoins en matière de technologie numérique et découvrir comment nous pouvons vous aider à booster votre présence en ligne",
  buttonLabel: "Nous-Contactez",
  imgStart: false,
  img: require("../../images/sending.png"),
  alt: "Envoyer un email",
  dark: false,
  primary: false,
  darkText: true,
};
